export default {
  authUserState: state => state.authUser,
  userInfoState: state => state.userInfo
}
